import { useRemoveQueryParam } from 'modules/common/hooks/useRemoveQueryParam'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { useIsSponsorshipEnabled } from '../hooks/useIsSponsorshipEnabled'
import { SPONSORSHIP_VOUCHER_CODE_QUERY_PARAM_KEY } from '../types/signup'
import { useValidateSponsorshipVoucherCodeFlow } from './useValidateSponsorshipVoucherCodeFlow'

export const usePrePopulateSponsorshipVoucherFlow = () => {
  const router = useRouter()
  const [isLoading, setIsLoading] = useState(false)

  const voucherCode = router.query[SPONSORSHIP_VOUCHER_CODE_QUERY_PARAM_KEY] as
    | string
    | undefined

  const { removeQueryParam } = useRemoveQueryParam()

  const { isSponsorshipEnabled } = useIsSponsorshipEnabled()

  const { validateSponsorshipVoucherCode } =
    useValidateSponsorshipVoucherCodeFlow({ voucherCode })

  useEffect(() => {
    if (isSponsorshipEnabled && voucherCode) {
      setIsLoading(true)
      validateSponsorshipVoucherCode().finally(() => {
        // Reset sponsorshipVoucherCode query param after validation to avoid side effects
        removeQueryParam(SPONSORSHIP_VOUCHER_CODE_QUERY_PARAM_KEY)
        setIsLoading(false)
      })
    }
  }, [
    isSponsorshipEnabled,
    removeQueryParam,
    router,
    validateSponsorshipVoucherCode,
    voucherCode,
  ])

  return { isPrePopulateSponsorshipVoucherLoading: isLoading }
}
